import Camera from "./Camera";
import Canvas from "./Canvas";
import FSM from "./FSM";
import Input from "./Input";
import Ticker from "./Ticker";
import Viewport from "./Viewport";
import Preloader from "./Preloader";

class Store {
    constructor () {
        this._items = {};
    }

    getItem (key) {
        return this._items[key];
    }

    setItem (key, val) {
        this._items[key] = val;
    }

    setItems (obj) {
        for (let key in obj) {
            this._items[keys] = obj[keys];
        }
    }

    clear (key) {
        if (typeof key === "string") {
            let item = this._items[key];
            this._items[key] = Array.isArray(item) ? [] : {};
        } else {
            this._items = {};
        }
    }

    serialize (key) {
        if (typeof key === "string") {
            return JSON.stringify(this._items[key]);
        } else {
            return JSON.stringify(this._items);
        }
    }

    deserialize (data) {
        return JSON.parse(data);
    }
}

/**
 * The Game object sets all core module instances as properties. It also takes width/height properties of the game
 * and takes the states for adding to the FSM; the first being the initially loaded state.
 * @class Game
 * @param {Integer} width The game width
 * @param {Integer} height The game height
 * @param {Object}  ]options] The game options
 * @param {Boolean} [options.container]         Container element for Spritewerk elements, defaults to <body>
 * @param {Boolean} [options.listenForMouse]    Whether or not to listen for mouse events
 * @param {Boolean} [options.listenForTouch]    Whether or not to listen for touch events
 * @param {Boolean} [options.listenForKeyboard] Whether or not to listen for keyboard events
 * @param {Boolean} [options.combineMouseAndClick] Combines mouse and touch events
 *                                                 eg: `click` triggers `tap` and visa-versa
 * @param {...State} states A key/val pair of the state and its name
 */
export default class Game {
    constructor (width, height, options={}, ...states) {
        this.width = width;
        this.height = height;
        this.viewport = new Viewport(width, height, options);
        this.ticker = new Ticker();
        this.camera = new Camera(0, 0, width, height);
        this.input = new Input(this.viewport.canvasElement, options);
        this.canvas = new Canvas(this.viewport.canvasElement, this.camera);
        this.fsm = new FSM(this.canvas, this.ticker, Preloader, this);
        this.store = new Store();

        let initialStateName;

        for (let state of states) {
            if (!initialStateName) {
                initialStateName = state.name;
            }

            this.fsm.add(state.state, state.name, state.args);
        }

        this.fsm.load(initialStateName);
    }
}



/** WEBPACK FOOTER **
 ** ./src/Game.js
 **/